import loadBasketModule from './modules/Basket.module';
import loadCompareModule from './modules/Compare.module';
import loadCustomerModule from './modules/Customer.module';
import loadFilterModule from './modules/FilterModule';
import loadListerModule from './modules/Lister.module';
import loadProductGroupModule from './modules/ProductGroup.module';
import loadUrlModule from './modules/Url.module';
import loadWishListModule from './modules/WishList.module';
const loadProductListerModule = (initialData) => ({
    hasRouter: true,
    modules: [
        // @TODO lister redux deprecation
        loadCompareModule(),
        loadFilterModule(initialData),
        loadListerModule(initialData),
        loadUrlModule(initialData),
        loadWishListModule(),
        loadBasketModule(),
        loadProductGroupModule(initialData),
        loadCustomerModule(),
    ],
});
export default loadProductListerModule;
